export enum CertifyStatus {
  NoCertified,
  PersonPending,
  PersonFailed,
  PersonPassed,
  PersonChangeEnterprise,
  EnterprisePending,
  EnterpriseFailed,
  EnterprisePassed,
  EnterpriseChange,
  StudentPending,
  StudentPassed,
  StudentExpire,
  StudentFail,
  EnterpriseFox,
  PersonaChangeFailed,
  EnterpriseChangeFailed,
  PersonalToEnterpriseFailed,
  PersonalChanging,
}
